module.exports = __webpack_public_path__ + "static/html-element-advanced-8e8a979bead44b4afe8f2c769dd111de.jpg";